// The on-screen legal-doc-* classnames are only styled via selectors scoped
// to their screen's ancestor (`.host-onboarding-root .scrollable-doc ...`,
// `.lease-agreement-gate-root .legal-gate-content ...`). The printed fragment
// doesn't carry those ancestor wrapper elements, so those scoped rules never
// match. This unscoped stylesheet re-declares the same look so printed/saved
// documents keep their formatting regardless of which screen printed them.
const legalDocumentPrintStyles = `
  .legal-doc-content { font-size: 13px; line-height: 1.65; color: #1a1a2e; }
  .legal-doc-header { text-align: center; border-bottom: 1px solid #dee2e6; padding-bottom: 12px; margin-bottom: 14px; }
  .legal-doc-org, .legal-doc-title { margin: 0 0 4px; font-size: 13px; color: #1a1a2e; }
  .legal-doc-meta { font-size: 11px; color: #adb5bd; margin: 0; }
  .legal-doc-content h3 { font-size: 14px; font-weight: 700; color: #1a1a2e; margin: 14px 0 6px; }
  .legal-doc-content p { margin-bottom: 10px; }
  .legal-doc-content ul { list-style: disc; padding-left: 20px; margin: 0 0 12px; }
  .legal-doc-content ol { padding-left: 22px; margin: 4px 0 10px; }
  .legal-doc-content ol li { list-style: lower-alpha; }
  .legal-doc-content li { margin-bottom: 4px; line-height: 1.6; }
  .legal-allcaps { font-size: 11.5px; line-height: 1.7; color: #1a1a2e; }
  .legal-callout { background: #eef1f7; border: 1px solid #c5ccee; border-radius: 6px; padding: 10px 14px; margin: 10px 0; font-size: 12px; line-height: 1.55; color: #1a1a2e; }
  .legal-info-table { width: 100%; border-collapse: collapse; margin: 6px 0 14px; font-size: 12px; }
  .legal-info-table td { padding: 6px 8px; border: 1px solid #dee2e6; vertical-align: top; color: #1a1a2e; line-height: 1.5; }
  .legal-info-table td:first-child { font-weight: 600; white-space: nowrap; width: 35%; }
  .legal-split-table { width: 100%; border-collapse: collapse; margin: 6px 0 14px; font-size: 12px; }
  .legal-split-table th { padding: 8px 12px; border: 1px solid #1F4E79; background: #1F4E79; color: #ffffff; font-weight: 700; text-align: left; }
  .legal-split-table td { padding: 10px 12px; border: 1px solid #dee2e6; text-align: center; font-weight: 700; font-size: 13px; color: #1a1a2e; }
  .legal-split-table td.legal-split-description { font-weight: normal; text-align: left; }
  .legal-doc-version { font-size: 11px; color: #adb5bd; margin-top: 14px; border-top: 1px solid #dee2e6; padding-top: 10px; }
  .legal-doc-link { color: #0d1d42; text-decoration: underline; }
  .lease-gate-addr { font-size: 11.5px; color: #6c757d; }
`;

export default legalDocumentPrintStyles;
